<template>
  <div class="flex gap-bento">
    <AtomsButton :to="localePath('subscribe')" class="grow shrink-0 rounded-r-[0]" :label="$t('pages.pricing')" hover-scheme="border" size="fluid" />
    <AtomsButton tag="a" href="#demo" class="grow shrink-0 rounded-l-[0]" :label="$t('showcase.demo')" hover-scheme="border" size="fluid" />
  </div>
</template>